import asyncComponent from 'app/common/utils/async-component';
import { submitForm } from 'app/schema-form/actions';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import { getDomainState } from '../../selectors';

const FormDialog = asyncComponent(() => import('./form-dialog'));

const mapDispatchToProps = {
  ...actions,
  submitForm
};

function mapStateToProps(state) {
  const formDialogState = getDomainState(state);
  return {
    active: formDialogState.get('active'),
    title: formDialogState.get('title'),
    config: formDialogState.get('config'),
    formName: formDialogState.get('formName'),
    instructions: formDialogState.get('instructions'),
    submitLabel: formDialogState.get('submitLabel')
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FormDialog);
